<template lang='pug'>
  .points-container
    heading-section(:title='title', :description='description', :hideDescription="hideDescription")
    .points
      .point(v-for='(point, index) in points')
        .img(:class='[`icon-${iconNumber(point.attributes.icon)}`]')
        .detail
          .title(v-text='point.attributes.title')
          .description(v-text='point.attributes.description')
</template>

<script>
import HeadingSection from './heading.vue'

export default {
  components: {
    HeadingSection
  },
  props: [
    'title',
    'description',
    'points',
    'hideDescription'
  ],

  methods: {
    iconNumber (payload) {
      return payload.substring(5, payload.length)
    }
  }
}
</script>

<style lang='scss' scoped>
  .points-container {
    padding-bottom: 30px;
    padding-top: 30px;

    @include media-breakpoint-up(xl) {
      align-content: space-between;
      display: flex;
      flex-flow: column wrap;
      height: 345px;
      justify-content: center;
      margin: 0 auto;
    }

    > .points {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      margin-top: 20px;
      text-align: left;

      @include media-breakpoint-up(sm) {
        flex-flow: column wrap;
        height: 230px;
      }

      @include media-breakpoint-up(xl) {
        margin: 0;
        order: 2;
        width: 630px;
      }
    }
  }

  .points {
    > .point {
      display: flex;
      justify-content: center;
      margin-bottom: 15px;
    }
  }

  .point {
    > .img {
      width: 56px;
      height: 56px;
      margin-right: 20px;
      background-size: 100%;
      background-repeat: no-repeat;
      background-position: center;
    }

    > .icon-1 {
      background-image: url('../../../assets/images/account/beauty_pass/Benefits_Icon-07.png');
    }
    > .icon-2 {
      background-image: url('../../../assets/images/account/beauty_pass/Benefits_Icon-09.png');
    }
    > .icon-3 {
      background-image: url('../../../assets/images/account/beauty_pass/Benefits_Icon-46.png');
    }
    > .icon-4 {
      background-image: url('../../../assets/images/account/beauty_pass/Benefits_Icon-45.png');
    }
    > .icon-5 {
      background-image: url('../../../assets/images/account/beauty_pass/Benefits_Icon-26.png');
    }
    > .icon-6 {
      background-image: url('../../../assets/images/account/beauty_pass/Benefits_Icon-32.png');
    }

    > .icon-7 {
      background: url('../../../assets/images/account/beauty_pass/icons/BP_Revamp_PointIcon_Web-7.svg');
    }

    > .detail {
      display: flex;
      flex-direction: column;
      justify-content: center;
      width: 200px;
    }
  }

  .detail {
    > .title {
      @include font-weight-medium;
    }
  }
</style>
